import type { FC } from 'react';

import { useGetAssessmentById } from '@/hooks/queries/assessment/useGetAssessmentById';

type Props = {
  assessmentId: string | undefined;
};

const Breadcrumb: FC<Props> = ({ assessmentId }) => {
  if (!assessmentId) {
    throw new Error('Missing assessmentId param');
  }
  const { data } = useGetAssessmentById({
    variables: { Id: assessmentId },
  });

  return <>{data?.assessment?.[0]?.Title || ''}</>;
};

export default Breadcrumb;
